const API_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const STAFF_AUDIT_LOG_PAGE_SIZE = 25;

export const STAFF_AUDIT_LOG_ORDER_BY = [
    { column: "CREATED_AT", order: "DESC" },
    { column: "ID", order: "DESC" },
];

const SUPPORTED_ACTIONS = [ "check_in", "check_out" ];
const SUPPORTED_RESULTS = [ "ACCEPTED", "REJECTED", "IGNORED" ];

const normalizeID = (value) => {
    const normalizedValue = String(value ?? "").trim();

    return normalizedValue || undefined;
};

const hasCompletePeriod = (period) => (
    period?.[ 0 ]?.isValid?.() && period?.[ 1 ]?.isValid?.()
);

const chainWhereConditions = (conditions) => conditions.reduceRight(
    (nextCondition, condition) => (
        nextCondition ? { ...condition, AND: [ nextCondition ] } : condition
    ),
    undefined
);

export const getStaffAuditActionVariable = (action) => (
    SUPPORTED_ACTIONS.includes(action) ? action : undefined
);

export const getStaffAuditResultVariable = (result) => {
    const normalizedResult = String(result || "").trim().toUpperCase();

    return SUPPORTED_RESULTS.includes(normalizedResult) ? normalizedResult : undefined;
};

export const buildStaffAuditWhere = ({ eeID, period, action } = {}) => {
    const eventID = normalizeID(eeID);

    if (!eventID)
    {
        return undefined;
    }

    const conditions = [ {
        column: "EE_ID",
        operator: "EQ",
        value: eventID,
    } ];

    if (hasCompletePeriod(period))
    {
        conditions.push(
            {
                column: "CREATED_AT",
                operator: "GTE",
                value: period[ 0 ].clone().startOf("day").format(API_DATE_TIME_FORMAT),
            },
            {
                column: "CREATED_AT",
                operator: "LTE",
                value: period[ 1 ].clone().endOf("day").format(API_DATE_TIME_FORMAT),
            }
        );
    }

    const normalizedAction = getStaffAuditActionVariable(action);

    if (normalizedAction)
    {
        conditions.push({
            column: "ACTION",
            operator: "EQ",
            value: normalizedAction,
        });
    }

    return chainWhereConditions(conditions);
};

export const buildStaffAuditWhereUser = (subcontractorID) => {
    const normalizedSubcontractorID = normalizeID(subcontractorID);

    return normalizedSubcontractorID ? {
        column: "SUBCONTRACTOR_ID",
        operator: "EQ",
        value: normalizedSubcontractorID,
    } : undefined;
};

export const getStaffAuditQueryState = ({
    eeID,
    period,
    action,
    result,
    subcontractorID,
} = {}) => ({
    where: buildStaffAuditWhere({ eeID, period, action }),
    whereUser: buildStaffAuditWhereUser(subcontractorID),
    result: getStaffAuditResultVariable(result),
});
